module.exports = __webpack_public_path__ + "static/media/creative-commons-pd.5ca6410c.svg";